<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 89 100">
    <defs>
      <path id="a" d="M0 0h89v99.903H0z" />
    </defs>
    <g fill="none" fill-rule="evenodd">
      <path
        :fill="iconColor"
        d="M63.644 70.628v3.232H53.092V59.54h3.681v11.088h6.871zM44.136 68.97H42.11l-2.638-3.846v8.735h-3.68V59.54h3.66l3.62 5.503 3.64-5.503h3.64v14.32h-3.661v-8.735l-2.556 3.846zm-22.577-6.199V59.54h12.29v3.232h-4.314V73.86h-3.681V62.772h-4.295zm53.614 22.259L45.55 93.143l-31.494-8.149-.084-.932h50.146a4.272 4.272 0 0 0 4.273-4.274V53.864a4.273 4.273 0 0 0-4.273-4.274H10.848L6.957 6.644h75.097l-6.881 78.387zM10.537 73.86h-3.68V59.54h3.68v5.094h5.399V59.54h3.68v14.32h-3.68v-5.953h-5.399v5.953zm77.59-72.783A3.32 3.32 0 0 0 85.68 0H3.321A3.32 3.32 0 0 0 .014 3.622l4.19 46.233a4.275 4.275 0 0 0-2.788 4.01v25.923a4.272 4.272 0 0 0 4.273 4.274H7.303l.35 3.863a3.322 3.322 0 0 0 2.475 2.916l34.615 8.956a3.326 3.326 0 0 0 1.708-.012l32.705-8.956a3.322 3.322 0 0 0 2.431-2.914l7.4-84.302a3.323 3.323 0 0 0-.86-2.535z"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-html',
    props: {
      width: {
        type: [Number, String],
        default: 89
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
